/* @flow */
import React, { Component } from 'react';
import cx from 'classnames';

import ConfirmDialog from 'components/ConfirmDialog.jsx';
import QuickPromotion from 'entities/QuickPromotion';
import { ImageTypes } from 'constants/QuickPromotionConstants';

import './styles/QuickPromotionModal.scss';

class QuickPromotionModal extends Component {
  props: {
    triggeredContext: string,
    promotion: QuickPromotion,
    onConfirm: (promotion: QuickPromotion) => void,
    onCancel: (promotion: QuickPromotion) => void,
    onRequestHide: () => any,
  };

  static childContextTypes = {
    eventScreenName: React.PropTypes.string,
    eventProperties: React.PropTypes.object,
  };

  getChildContext() {
    return {
      eventScreenName: 'QuickPromotionModal',
      eventProperties: { ui_context: this.props.triggeredContext },
    };
  }

  onConfirm = () => {
    this.props.onConfirm(this.props.promotion);
  }

  onCancel = () => {
    this.props.onCancel(this.props.promotion);
  }

  render() {
    let secondaryButton = false;
    let secondaryButtonText = '';
    const secondaryAction = this.props.promotion.getSecondaryAction();

    if (secondaryAction) {
      secondaryButton = true;
      secondaryButtonText = secondaryAction.getLabel();
    }

    return (
      <ConfirmDialog
        eventScreenName="QuickPromotionModal"
        className={cx('QuickPromotionModal', {
          'with-banner': this.props.promotion.getImageType() === ImageTypes.BANNER,
        })}
        size="xsmall"
        hideCloseButton
        hideOnTransition={false}
        hideOnBlur={false}
        title={this.props.promotion.getHeader()}
        subtext={this.props.promotion.getBody()}
        image={this.props.promotion.getImageUrl()}
        actionButtonText={this.props.promotion.getPrimaryAction().getLabel()}
        hideCancel={!secondaryButton}
        cancelButtonText={secondaryButtonText}
        imageSize="large"
        onConfirm={this.onConfirm}
        onCancel={this.onCancel}
        onRequestHide={this.props.onRequestHide}
      />
    );
  }
}

export default QuickPromotionModal;



// WEBPACK FOOTER //
// ./src/components/QuickPromotionModal.jsx